/* jslint browser: true */
import React, { Component } from 'react';
import PropTypes            from 'prop-types';
import Dropzone             from 'react-dropzone';
import axios                from 'axios';
import {apiUrl}               from '../../lib/constants';
import Modal                from 'react-modal';

/**
 * Corps d'un bloc de type Annexe
 */
class AnnexeBlockBody extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title           : this.props.block.titre,
            pdfFile         : (this.props.block.nomInitial ? { name: this.props.block.nomInitial } : null),
            downloadUrl     : this.props.block.nomFinal, // TODO: à voir...
            validationError : '',
            isOpenModal     : false,
        };

        this.onFileDrop         = this.onFileDrop.bind(this);
        this.onTitleChange      = this.onTitleChange.bind(this);
        this.removeFile         = this.removeFile.bind(this);
        this.updateBlockTitle   = this.updateBlockTitle.bind(this);
        this.closeModal         = this.closeModal.bind(this);
        this.openModal          = this.openModal.bind(this);
    }

    /**
     * Permet d'ouvrir la popup de suppression
     */
    openModal() {
        this.setState({ isOpenModal: true });
    }

    /**
     * Permet de fermer la popup de suppression
     */
    closeModal() {
        this.setState({ isOpenModal: false });
    }

    /**
     * Upload le fichier PDF
     * @param {type} acceptedFiles
     */
    onFileDrop(acceptedFiles) {
        if (acceptedFiles.length > 0) {
            var data = new FormData();
            data.append('file', acceptedFiles[0]);
            // On envoi le fichier et on sauvegarde l'url dans downloadUrl
            axios.post(apiUrl + '/api/v1/admin/annexe/' + this.props.block.id_annexe + '/upload', data).then((response) => {
                this.setState({
                    pdfFile     : acceptedFiles[0],
                    downloadUrl : response.data.URL,
                });
            });
        }
    }

    /**
     * Change le titre du bloc
     * @param {type} event Correspond à l'event de modification
     */
    onTitleChange(event) {
        this.setState({
            title : event.target.value,
        });
    }

    /**
     * Supprime le fichier PDF
     * @param {type} event Correspond à l'event de suppression
     */
    removeFile(event) {
        event.stopPropagation();
        axios.delete(apiUrl + '/api/v1/admin/annexe/' + this.props.block.id_annexe + '/PDF').then(() => {
            this.setState({
                pdfFile     : null,
                downloadUrl : null,
            });
        });
    }

    updateBlockTitle() {
        if (!this.state.title) {
            this.setState({
                validationError : 'Le titre ne peut pas être vide.',
            });
        } else {
            axios.put(
                apiUrl + '/api/v1/admin/annexe',
                {
                    id_annexe  : this.props.block.id_annexe,
                    titre      : this.state.title
                },
            ).then((response) => {
                this.setState({
                    validationError : '',
                });

                this.props.updateBlockTitle(this.state.title);
            });
        }
    }

    render() {
        const block = this.props.block;

        return (<div className="row annexe-block-body" style={{ display: !this.props.isBlockOpen ? 'none' : '' }}>
            <div className="col-sm-12">
                <Modal
                    isOpen={this.state.isOpenModal}
                    onRequestClose={this.closeModal}
                    style={{
                        overlay : {
                            backgroundColor : 'rgba(0, 0, 0, 0.75)',
                            zIndex          : 9,
                        },
                        content : {
                            position     : 'absolute',
                            border       : '1px solid rgb(204, 204, 204)',
                            background   : 'rgb(255, 255, 255)',
                            overflow     : 'auto',
                            borderRadius : '4px',
                            outline      : 'none',
                            padding      : 'unset',
                            bottom       : 'unset',
                            maxHeight    : '95vh',
                            textAlign    : 'center',
                            width        : '100%',
                            maxWidth     : '900px',
                            top          : '50%',
                            left         : '50%',
                            transform    : 'translate(-50%, -50%)',
                        },
                    }} >
                    <h2>Suppression d'une annexe</h2>
                    <br />
                    <p style={{ fontSize: '15px' }}>
                            Êtes-vous sûr de vouloir supprimer cette annexe ?
                    </p>
                    <button type="button" className="btn myBtn myBtnDanger" onClick={e => this.props.removeBlock(block)}>Oui</button>
                    <button type="button" className="btn myBtn" onClick={e => this.closeModal()}>Non</button>
                </Modal>
                <div className="col-sm-4">
                    <div className="arrows">
                        <i style={{ cursor: 'pointer' }} className="fa fa-arrow-up" aria-hidden="true" onClick={e => this.props.moveBlock(block, 'up')} />
                        <i style={{ cursor: 'pointer' }} className="fa fa-arrow-down" aria-hidden="true" onClick={e => this.props.moveBlock(block, 'down')} />
                    </div>
                    <button type="button" className="btn myBtn myBtnDanger" onClick={e => this.openModal()}>Supprimer</button>
                </div>
                <div className={ 'col-sm-4 dropzone ' + (this.state.pdfFile === null ? 'empty' : '') }>
                    { this.state.pdfFile === null ?
                        <Dropzone
                            accept=".pdf"
                            onDrop={this.onFileDrop}>
                            <span className="dropzone-label">Cliquer ou glisser un PDF ici</span>
                        </Dropzone>
                        : <div style={{ position: 'relative', border: '1px solid grey' }}>
                            <a href={this.state.downloadUrl} target="_blank" style={{ textDecoration: 'none', color: 'black' }}>
                                <img src="/pictures/pdf_download.png" width="70" alt="pdf-download" style={{ float: 'left', marginTop: '20px' }} />
                                <div className="dropzone-filename">
                                    {this.state.pdfFile.name}
                                </div>
                            </a>
                            <i
                                    className="fa fa-times"
                                    aria-hidden="true"
                                    onClick={this.removeFile}
                                    style={{
                                        cursor: 'pointer', position : 'absolute', top      : '0px', right    : '2px', color    : 'red', float    : 'right',
                                    }} />
                        </div>
                    }
                </div>
                <div className="col-sm-4">
                    <label>Nom</label>
                    <input type="text" value={this.state.title} onChange={this.onTitleChange} />
                    <button type="button" className="btn myBtn" onClick={this.updateBlockTitle}>Modifier</button>
                    <div className="error-msg">
                        {this.state.validationError}
                    </div>
                </div>
            </div>
        </div>);
    }
}

AnnexeBlockBody.propTypes = { block: PropTypes.object };

export default AnnexeBlockBody;



// WEBPACK FOOTER //
// ./src/components/annexes/AnnexeBlockBody.js